import { useCommonData } from '../common-data/useCommonData';
import { getUrlForPageId } from './getUrlForLink';

export function useUrlForPageId(pageId: string) {
	const { pathToPageIdMap } = useCommonData();

	return getUrlForPageId(pageId, pathToPageIdMap);
}
